import { SkeletonBox } from '@practium/ui';
import { ChartCard } from '../ChartCards/ChartCard';
import styles from './MetricListCard.module.css';

interface MetricItem {
	id: string | number;
	name: string;
	value?: string | number;
	tone?: 'default' | 'danger';
}

export interface MetricListCardProps {
	title: string;
	subtitle: string;
	buttonText: string;
	onButtonClick: () => void;
	data: MetricItem[];
	emptyMessage?: string;
	showRank?: boolean;
	isLoading?: boolean;
}

const SKELETON_ITEMS = 4;

const MetricListSkeleton = ({ showRank }: { showRank: boolean }) => (
	<div className={styles.listContainer}>
		{Array.from({ length: SKELETON_ITEMS }, (_, index) => (
			<div key={index} className={styles.item}>
				<div className={`${styles.itemLeft} ${styles.skeletonLeft}`}>
					{showRank && <SkeletonBox width="2rem" height="2rem" borderRadius="50%" style={{ flexShrink: 0 }} />}
					<SkeletonBox width="100%" height="0.8rem" style={{ maxWidth: '9rem' }} />
				</div>
				<SkeletonBox width="30%" height="0.8rem" style={{ maxWidth: '5rem', marginLeft: '1rem' }} />
			</div>
		))}
	</div>
);

export const MetricListCard = ({
	title,
	subtitle,
	buttonText,
	onButtonClick,
	data,
	emptyMessage,
	showRank = true,
	isLoading,
}: MetricListCardProps) => {
	const isEmpty = !data || data.length === 0;

	return (
		<ChartCard
			title={title}
			subtitle={subtitle}
			buttonText={buttonText}
			onButtonClick={onButtonClick}
			isEmpty={isEmpty}
			emptyMessage={emptyMessage}
			isLoading={isLoading}
			skeleton={<MetricListSkeleton showRank={showRank} />}
		>
			<div className={styles.listContainer}>
				{data.map((item, index) => (
					<div key={item.id} className={styles.item}>
						<div className={styles.itemLeft}>
							{showRank && <div className={styles.rankWrapper}>{index + 1}</div>}
							<span className={styles.itemName}>{item.name}</span>
						</div>
						{item.value !== undefined && item.value !== null && (
							<span
								className={`${styles.itemValue} ${item.tone === 'danger' ? styles.itemValueDanger : ''}`}
							>
								{item.value}
							</span>
						)}
					</div>
				))}
			</div>
		</ChartCard>
	);
};
